import { useContext, useState } from 'react'

import Container from '../basic-components/Container'
import Content from '../basic-components/Content'
import { Header } from '../basic-components/HeaderFooter'
import HeaderTitle from '../basic-components/HeaderTitle'
import List from '../basic-components/List'
import ListItem from '../basic-components/ListItem'
import Text from '../basic-components/Text'

import BackIcon from '../icons/BackIcon'
import CheckIcon from '../icons/CheckIcon'
import IconContainer from '../icons/IconContainer'

import Checkbox from '../basic-components/Checkbox'

import MapContext from '../context/MapContext'


export default function LayersPage({ menuItems, onChange, onBackClick }) {
  const { olMap, layersConfig } = useContext(MapContext);
  const [changed, setChanged] = useState(false);

  //console.log(olMap);
  //console.log(layersConfig);

  const itemClickHandler = (e) => {
    //console.log(layers);
    //console.log(e.target);
    //console.log(e.target.value);
    //console.log(layersConfig[e.target.value]);
    const layer = olMap.getLayerByName(layersConfig[e.target.value].name);
    if (layer) {
      //console.log(layer);
      layer.setVisible(!layer.getVisible());
      setChanged(!changed);
    }
  }

  const layers = olMap.getLayers().getArray();

  let listItems;
  if(layers) {
    //console.log('setting up layers');
    //console.log(layers);
    //console.log(layers[0].getProperties());

    listItems = layersConfig.map((layerConfig, i) => {
      const layer = olMap.getLayerByName(layerConfig.name);
      //console.log(layer);
      //console.log(layer.getVisible());
      return (
        <ListItem value={i}
          key={layerConfig.name}
          onClick={itemClickHandler}
        >
          <Checkbox style={{pointerEvents: 'none'}} >
            {(layer && layer.getVisible()) ? (
              <CheckIcon
                transform="up-10 left-6"
                style={{pointerEvents: 'none'}}
              />
            ) : null }
          </Checkbox>
          <Text>
            {layerConfig.text}
          </Text>
        </ListItem>
      );
    });
  }

  return (
    <Container>
      <Header style={{fontSize: '1rem'}}>
        <IconContainer>
          <BackIcon onClick={onBackClick}/>
        </IconContainer>
        <HeaderTitle><strong>Layers</strong></HeaderTitle>
        <IconContainer/>
      </Header>
      <Content>
        <List>
          {listItems ? listItems.map((item) => item) : null}
        </List>
      </Content>
    </Container>

  );
}
